.wrapper {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: calc(100dvw - 32px);
  bottom: 16px;
  overflow: hidden;
  z-index: var(--z-toast);
}

.wrapper--unweightedPdp {
  bottom: calc(80px + 8px);
}

.wrapper--weightedPdp {
  bottom: calc(152px + 8px);
}

@keyframes animate-in {
  0% {
    transform: translateY(-100%);
  }

  100% {
    transform: translateY(0%);
  }
}

@keyframes animate-out {
  0% {
    transform: translateY(0%);
  }

  100% {
    transform: translateY(-100%);
  }
}

.animated {
  animation: animate-in 0.25s ease;
}

.animated.leaving {
  animation: animate-out 0.25s ease;
}

.container {
  display: flex;
  margin-bottom: 4px;
  background-color: var(--colors-grays-black);
  color: var(--colors-grays-white);
  opacity: 0.69;
  box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 25%) inset;
  padding: 16px;
  border-radius: var(--border-radius-sm);
  font-weight: var(--font-weight-semibold);
}

.container > div {
  padding: 0;
}

@media all and (--reefer-media-tablet-min) {
  .wrapper {
    top: calc(var(--header-height) + 8px);
    bottom: unset;
  }

  .wrapper--account {
    top: calc(var(--header-height) + 88px + 8px); /* Header + name strip */
  }

  .wrapper--locationStoreBanner {
    top: calc(var(--header-height) + 8px + 50px); /* Header + banner */
    bottom: unset;
  }
}
